<template>
    <div v-if="punctaj && punctaj.criterii">
        <span class="background-title">Punctaj posibil</span>
        <div style="padding-top: 25px">
            <ul>
                <li class="flex space-between" style="align-items: flex-start">
                    <div style="width: 90%">
                        <span class="item-title">Scăderea cifrei de afaceri în anul 2020 în raport cu anul 2019</span>
                        <!--                         eslint-disable-next-line-->
                        <span class="item-description" :class="getCADifferenceClass()">Punctajul a fost calculat in conformitate cu prevederile ghidului solicitantului (≥30% - 40 puncte / ≥25 < 30% - 35 puncte / ≥20 < 25% - 30 puncte / ≥15 < 20% - 25 puncte ≥10 < 15% - 20 puncte /  ≥5 < 10%  - 15 puncte / < 5%  - 0 puncte (proiect respins)</span>
                    </div>
                    <div>
                        <span class="item-score" :class="getCADifferenceClass()">{{ getCADifferencePoints() }}</span>
                    </div>
                </li>
                <hr>
                <li class="flex space-between" style="align-items: flex-start">
                    <div style="width: 90%">
                        <span class="item-title">{{ punctaj.criterii[1].name }}</span>
                        <!--                         eslint-disable-next-line-->
                        <span class="item-description" :class="punctaj.criterii[1].value === 40 ? 'green' : ''">Investiție de minim 20% din valoarea proiectului în conformitate cu prevederile Anexei I din Propunerea de REGULAMENT DELEGAT AL COMISIEI (UE) de completare a Regulamentului (UE) 2020/852 al Parlamentului European și al Consiliului privind stabilirea criteriilor tehnice de screening pentru determinarea condițiilor în care o activitate economică se califică ca contribuind în mod substanțial la atenuarea schimbărilor climatice <br><br> ≥90% din valoarea proiectului contribuie la obiectivele de mediu – 40 puncte / ≥80 < 90% - 35 puncte / ≥70 < 80% - 30 puncte /  ≥60 < 70% - 25 puncte / ≥50 < 60% - 20 puncte / ≥40 < 50% - 15 puncte / ≥30 < 40% - 10 puncte /  ≥20 < 30% - 5 puncte / < 20% - 0 puncte (proiect respins)</span>
                    </div>
                    <div>
                        <span class="item-score" :class="punctaj.criterii[1].value === 40 ? 'green' : ''">{{ punctaj.criterii[1].value }}</span>
                    </div>
                </li>
                <hr>
                <li class="flex space-between" style="align-items: flex-start">
                    <div style="width: 90%">
                        <span class="item-title">{{ punctaj.criterii[2].name }}</span>
                        <!--                         eslint-disable-next-line-->
                        <span class="item-description" :class="punctaj.criterii[2].value === 5 ? 'green' : punctaj.criterii[2].value === 0 ? 'red': ''">Sold negativ - 5 puncte /  Sold pozitiv - 0 puncte</span>
                    </div>
                    <div>
                        <span class="item-score" :class="punctaj.criterii[2].value === 5 ? 'green' : punctaj.criterii[2].value === 0 ? 'red': ''">{{ punctaj.criterii[2].value }}</span>
                    </div>
                </li>
                <hr>
                <li class="flex space-between" style="align-items: flex-start">
                    <div style="width: 90%">
                        <span class="item-title">{{ punctaj.criterii[3].name }}</span>
                        <!--                         eslint-disable-next-line-->
                        <span class="item-description" :class="punctaj.criterii[3].value === 5 ? 'green' : ''">DA - 5 puncte /  NU - 0 puncte</span>
                    </div>
                    <div>
                        <span class="item-score" :class="punctaj.criterii[3].value === 5 ? 'green' : ''">{{ punctaj.criterii[3].value }}</span>
                    </div>
                </li>
                <hr>
                <li class="flex space-between" style="align-items: flex-start">
                    <div style="width: 90%">
                        <span class="item-title">{{ punctaj.criterii[4].name }}</span>
                        <!--                         eslint-disable-next-line-->
                        <span class="item-description" :class="punctaj.criterii[4].value === 10 ? 'green' : ''">≥15% – 10 puncte /  ≥10% < 15% - 5 puncte /  < 10%  0 puncte</span>
                    </div>
                    <div>
                        <span class="item-score" :class="punctaj.criterii[4].value === 10 ? 'green' : ''">{{ punctaj.criterii[4].value }}</span>
                    </div>
                </li>
            </ul>
        </div>
        <div class="flex align-center space-between mt-5 punctaj-btns">
            <span class="scrieProiect" @click="$emit('addM3Company')" >Scrie proiect</span>
            <span class="cautaConsultant" @click="$emit('openConsultantModal')" >Caută un consultant</span>
        </div>
    </div>
</template>

<script>
    export default{
        props: {
            data: null,
        },
        data() {
            return {
                punctaj: null,
            }
        },
        watch: {
            data: function() {
                this.punctaj = this.data;
                this.checkScore();
            }
        },
        mounted(){
            this.punctaj = this.data;
            this.checkScore();
        },
        updated() {
            this.sendScore()
        },
        methods: {
            checkScore(){
                if(this.punctaj){
                    if(!this.punctaj.cf2020) {
                        this.punctaj.cf2020 = 0
                    }
                    if(this.punctaj.cf2019){
                        if(this.punctaj.cf2020 < this.punctaj.cf2019){
                            let percentage =100 - Number(this.punctaj.cf2020) / Number(this.punctaj.cf2019) * 100;
                            if(percentage >= 30)
                                this.punctaj.criterii[0].value = 40;
                            else {
                                if(percentage >= 25)
                                    this.punctaj.criterii[0].value = 35;
                                else{
                                    if(percentage >= 20)
                                        this.punctaj.criterii[0].value = 30;
                                    else{
                                        if(percentage >= 15)
                                            this.punctaj.criterii[0].value = 25;
                                        else{
                                            if(percentage >= 10)
                                                this.punctaj.criterii[0].value = 20;
                                            else{
                                                if(percentage >= 5)
                                                    this.punctaj.criterii[0].value = 15;
                                                else{
                                                    this.punctaj.criterii[0].value = 0;
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                        else{
                            this.punctaj.criterii[0].value = 0;
                        }
                        this.punctaj.punctaj = 0;
                        this.punctaj.criterii.forEach(criteriu => {
                            this.punctaj.punctaj += criteriu.value;
                        })
                    }
                    this.sendScore()
                }
            },
            getCADifference() {
                let vechi = this.data.cf2019
                let nou = this.data.cf2020
                let difference = (vechi - nou) * 100 / vechi
                if(difference < 0) {
                    difference = 0
                }
                return difference
            },
            getCADifferenceClass() {
                let difference = this.getCADifferencePoints()

                if(difference === 0) {
                    return 'red'
                } else if(difference === 15 || difference === 20 || difference === 25) {
                    return 'orange'
                } else if(difference === 30 || difference === 35) {
                    return 'light-green'
                } else if(difference === 40) {
                    return 'green'
                }
            },
            getCADifferencePoints() {
                let difference = this.getCADifference()

                if(difference <= 5) {
                    return 0
                } else if(difference >= 5 && difference < 10) {
                    return 15
                } else if(difference >= 10 && difference < 15) {
                    return 20
                } else if(difference >= 15 && difference < 20) {
                    return 25
                } else if(difference >= 20 && difference < 25) {
                    return 30
                } else if(difference >= 25 && difference < 30) {
                    return 35
                } else if(difference >= 30) {
                    return 40
                }

                this.sendScore()
            },
            sendScore() {
                this.$emit('scoreCalculated', this.punctaj.criterii)
            }
        }
    }
</script>

<style scoped>
.module-title{
    font-size: 14px;
    color: #3b4369;
    font-weight: 700;
}
.flex{
    display: flex;
}
.space-between{
    justify-content: space-between;
}
.align-center{
    align-items: center;
}
.left-items{
    width: 70%;
}
.right-items{
    width: 20%;
    display: flex;
    flex-direction: column;
    align-items: center;
}
.item-title{
    font-size: 14px;
    color: #5b607a;
    font-weight: 700;
    display: flex;
    margin-bottom: 5px;
}
.item-score{
    font-weight: 500;
    color: #3b4369;
    display: flex;
    font-size: 32px;
}
.blue{
    color: #00a5d4;
}
.green{
    color: #59b395;
}
.light-green{
    color: #9BD483;
}
.orange{
    color: #FAAF7C;
}
.red{
    color: #ff5050;
}
.left-items li{
    margin: 15px 0;
}
.total-points{
    margin-top: -25px;
    font-size: 30px;
    font-weight: 800;
    color: #3b4369;
    text-align: center;
}
.background-title{
  border: 1px solid #e5e5e9;
  background: #f1f1f4;
  color: #3b4369;
  font-size: 12px;
  padding: 4px 3px;
  font-weight: 600;
}
.item-description{
  font-size: 12px;
}
.scrieProiect{
    background-color: #36ad8c;
    color: #ffffff;
    border-radius: 5px;
    cursor: pointer;
    width: 100%;
    max-width: 200px;
    text-align: center;
    padding: 4px;
    font-size: 13px;
}
.cautaConsultant{
    background-color: #ff6767;
    color: #ffffff;
    cursor: pointer;
    width: 100%;
	max-width: 200px;
    text-align: center;
    border-radius: 3px;
    padding: 4px 25px;
    max-height: 40px;
    display: flex;
    font-size: 13px;
    align-items: center;
    justify-content: center;
}
@media (max-width: 1050px){
    .left-items{
        width: 69%;
    }
    .right-items{
        width: 28%;
    }
}
@media (max-width: 700px){
    .flex{
        display: block;
    }
    .left-items .flex{
        display: flex;
    }
    .left-items, .right-items{
        width: 100%;
    }
    .right-items{
        margin-bottom: 20px;
    }
    .align-center{
        display: flex;
    }
}
@media screen and (max-width: 420px) {
  .punctaj-btns {
    flex-direction: column;
    margin-top: 10px!important;
  }
  .punctaj-btns span {
    max-width: 100%;
  }
  .punctaj-btns span:first-of-type {
    margin-bottom: 10px;
  }
}
</style>
